<div class="sot-select-account seed-return-add-prod" (window:resize)="onresize($event)">

  <div class="prod-top-sec">
    <h3 class="xs-pl-0">
      Search and Select Account
    </h3>
  </div>
  <div>
    <a class="close-btn-account" (click)="onDialogClose()">
      Close <i class="fas fa-times"></i>
    </a>
  </div>

  <div class="inline-error" *ngIf="enableErrorMsg">
    <div class="row">
      <div class="col-md-12 ">
        <ol class="error-list">
          <li class="justify-content-center align-self-center">
            {{ErrorMessage}}
          </li>
        </ol>
      </div>
    </div>
  </div>

  <form #searchAccountForm="ngForm" autocomplete="off" (ngSubmit)="searchAccount(searchAccountForm)">

    <div class="row prod-top-sec">
      <div class="col-md-3 padTop13">
        <mat-form-field class="wide100 addSelectInput" [class.invalid-field]="brwErrorModel.BusinessName" floatLabel="never">
          <input matInput type=text name="BusinessName"
                 placeholder="Account Name"
                 [(ngModel)]="brwModel.BusinessName"
                 minlength="2"
                 #bnCtrl="ngModel"
                 (focusout)="lengthValidation('businessName', brwModel.BusinessName)"
                 autocomplete="off">
        </mat-form-field>
      </div>

      <div class="col-md-3 padTop13">
        <mat-form-field class="wide100 addSelectInput" [class.invalid-field]="brwErrorModel.City" floatLabel="never">
          <input matInput type=text name="City"
                 placeholder="City"
                 [(ngModel)]="brwModel.City"
                 minlength="2"
                 #cnCtrl="ngModel"
                 (focusout)="lengthValidation('City', brwModel.City)"
                 autocomplete="off">
        </mat-form-field>
      </div>

      <div class="col-md-3 material-select stateSelect">
        <ng-select id="ddlState"
                   name="State"
                   placeholder="State"
                   class="custom-select-grower"
                   [(ngModel)]="brwModel.State"
                   [items]="stateDS"
                   [multiple]="false"
                   [hideSelected]="true"
                   [virtualScroll]="true"
                   bindLabel="value"
                   bindValue="id"
                   [closeOnSelect]="true">
          <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
            <div class="dropdown-template">
              <div class="row">
                <div class="col-md-8">
                  <p class="name">
                    {{item.value}}
                  </p>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
            <div class="ng-option disabled">
              No data found for ""
            </div>
          </ng-template>
        </ng-select>
      </div>
      <div class="col-md-3 text-center pt-3">
        <div>
          <button id="btnSearch" mat-raised-button class="btns width-150" color="primary" [disabled]="(brwModel.City=='' && brwModel.State==null && brwModel.BusinessName=='' && brwModel.AccountNo == '')" type="submit">Search</button>
        </div>
      </div>
    </div>
    <div class="row prod-top-sec">
      <div class="col-md-3 padTop13">
        <mat-form-field class="wide100 addSelectInput" [class.invalid-field]="brwErrorModel.AccountNo" floatLabel="never">
          <input matInput type="text" name="AccountNo"
                 placeholder="Account No."
                 [(ngModel)]="brwModel.AccountNo"
                 #cnCtrl="ngModel"
                 autocomplete="off"
                 (keypress)="keyPressNumbers($event)">
        </mat-form-field>
      </div>
    </div>
  </form>
  <hr />

  <div class="row ">
    <div class="col-md-10 filterOuter filterLength">
      <app-efulfillmentfilter [filters]="filterArray" [IsFulfilmentTab]="true" [IsFilterData] ="true" (SearchFilter)="filterGrid($event)"></app-efulfillmentfilter>
    </div>
    <div class="col-md-12 growerSearchTable internalProductTransfer">
      <app-efulfillmenttable [propHeaderDS]="headerList" [propBodyDS]="growerDS" (RowClick)="SelectAccount($event)" [propIsCellColorEnable]="true"></app-efulfillmenttable>
    </div>
  </div>
</div>
